import { formatCurrencyToNumber } from '../../helper/publicacionHelper';
import {
    postRebatesApi,
    updateRebatesApi,
} from '../../api/axios';
import { toast } from 'react-toastify';

export const sendOrUpdateRebate = ({ event, rebateRequest, publicacion, updateDataRebate, rebateState }) => {
    if (event.target.name === "send") {
        rebateRequest.precioInicial = formatCurrencyToNumber(publicacion.precioPromocional);

        if (rebateRequest.precioInicial == null || rebateRequest.precioInicial === 0) {
            rebateRequest.precioInicial = formatCurrencyToNumber(publicacion.precioLista);
        }
        const req = postRebatesApi(rebateRequest);
        req.then(response => {
            toast.success("Rebate enviado");
            updateDataRebate(publicacion.idPublicacion);
            return null;
        })
        .catch(err => {
            if (err.response?.data?.errors) {
                err.response.data.errors.forEach(error => {
                    toast.error(error.message);
                });
            } else {
                toast.error("No pudo crearse");
            }
        })
    } else {
        rebateRequest.idRebate = rebateState.idRebate;
        const req = updateRebatesApi(rebateRequest);
        req.then(response => {
            toast.success("Rebate modificado");
            updateDataRebate(publicacion.idPublicacion);
            let rebate = updateDataRebate(publicacion.idPublicacion);
            return rebate;
        }).catch(err => {
            const errores = err?.response?.data?.errors;
            if (errores && Array.isArray(errores)) {
                errores.forEach(error => toast.error(error.message)); // <<< usar solo el mensaje
            } else {
                toast.error("No pudo modificarse. Revise y/o complete los campos requeridos");
            }
        });
    }
}